import { useOutletContext } from "react-router-dom";
import { Users } from "lucide-react";
import { Reveal, useSeo } from "@/components/site/Motion";
import { site } from "@/content/site";

export const JournalAbout = () => {
  const { journal } = useOutletContext();
  useSeo(`About the Journal · ${journal.title}`, journal.excerpt);
  return (
    <Reveal data-testid="journal-about">
      <p className="eyebrow mb-5">About</p>
      <h1 className="font-display text-5xl sm:text-6xl leading-[1.02] mb-10">About the Journal</h1>
      <div className="prose-mp text-lg max-w-3xl">{journal.about.map((p, i) => <p key={i}>{p}</p>)}</div>
      <div className="mt-12 border-t border-[var(--line)] pt-8">
        <h2 className="font-mono-x text-xs tracking-[0.2em] uppercase text-[var(--ink-muted)] mb-4">Sections</h2>
        {site.sections.map((s) => (
          <div key={s.title} className="flex justify-between py-3 border-b border-[var(--line)]"><span className="font-display text-2xl">{s.title}</span><span className="text-[var(--ink-muted)]">{s.policy}</span></div>
        ))}
      </div>
    </Reveal>
  );
};

export const EditorialTeam = () => {
  const { journal } = useOutletContext();
  useSeo(`Editorial Team · ${journal.title}`);
  return (
    <Reveal data-testid="editorial-team">
      <p className="eyebrow mb-5">About</p>
      <h1 className="font-display text-5xl sm:text-6xl leading-[1.02] mb-10">Editorial Team</h1>
      <div className="border border-dashed border-[#CFC6B8] bg-white/60 p-10">
        <Users className="w-10 h-10 text-[var(--emerald)] mb-6" strokeWidth={1.25} />
        <p className="text-lg text-[var(--ink-muted)] max-w-xl" data-testid="editorial-team-empty">The editorial board for {journal.title} will be listed here once published in the journal settings.</p>
      </div>
    </Reveal>
  );
};

export const Privacy = () => {
  const { journal } = useOutletContext();
  useSeo(`Privacy Statement · ${journal.title}`);
  return (
    <Reveal data-testid="privacy-statement">
      <p className="eyebrow mb-5">About</p>
      <h1 className="font-display text-5xl sm:text-6xl leading-[1.02] mb-10">Privacy Statement</h1>
      <blockquote className="font-display text-3xl leading-snug border-l-2 border-[var(--gold)] pl-8 max-w-3xl">{site.privacy}</blockquote>
    </Reveal>
  );
};
